







































import { Component, Vue, Prop } from 'vue-property-decorator';
interface step {
  label: string;
  link: string;
}

@Component({})
export default class DashboardProgress extends Vue {
  steps: step[] = [
    { label: 'Account Created', link: '/new-signup' },
    { label: 'Connect Stripe', link: '/settings/stripe-profile' },
    { label: 'Merchant ID (MID)', link: '/settings/business' },
    { label: 'Birthday Club', link: '/birthday-club' },
    { label: 'Loyalty & Rewards', link: '/loyalty-and-rewards' },
    { label: 'General Offers', link: '/offers' },
    { label: 'Check out Integrations', link: '/settings/apps' }
  ];

  @Prop({ default: 0 }) stepsActive!: boolean[];
  @Prop({ default: false }) loading!: boolean;

  goTo(link: string) {
    this.$router.push(link);
  }

  get allStepsActive(): boolean {
    return this.stepsActive.every(step => step);
  }

  get stepsTrue(): number {
    return this.stepsActive.filter(step => step).length;
  }

  get getProgressAsPercentage() {
    return (100 / this.steps.length) * this.stepsTrue;
  }

  get title() {
    if (this.allStepsActive) return `Whoohoo, you're all set!`;
    return `Complete your registration (${Math.round(
      this.getProgressAsPercentage
    )}%)`;
  }
}
